import CarServicesList from "../components/car-services-list/car-services-list";
import { Role } from "@/core/auth/models/role.model";
import { Link } from "react-router-dom";
import { Plus, Settings } from "lucide-react";
import { Button, buttonVariants } from "@/components/ui/button";
import withAuthorization from "@/core/auth/components/withAuthorization";
import RoleGuard from "@/core/auth/components/role-guard";
import { useQuery } from "@tanstack/react-query";
import { getCarServices } from "@/services/getCarServices";
import { useAuth } from "@/core/auth/contexts/AuthContext";

function CarServices() {

  const { user } = useAuth();

  const {
    data: carServices,
    isPending,
    isError,
    error,
  } = useQuery({
    queryKey: ["car-services"],
    queryFn: async () => getCarServices(),
    select: (data) => {
      return data.map((service: any) => ({
        ...service,
        companyName: service.company.name,
      }));
    },
    enabled: !!user?.company?._id || user?.role === "super-admin",
  });
  return (
    <div className="p-6 w-full mx-auto space-y-6">
      
      <div className="flex items-center justify-between mb-8">
        <div className="space-y-1">
          <h1 className="text-3xl font-bold tracking-tight">Car Services</h1>
          <p className="text-muted-foreground">
            Manage your available car services and pricing
          </p>
        </div>

        <RoleGuard requiredRoles={[Role.CompanyAdmin, Role.SuperAdmin]}>
          <Link
            to="/app/add-carservice"
            className={buttonVariants({
              variant: "default",
              className: "flex items-center gap-2",
            })}
          >
            <Plus className="h-5 w-5" />
            Add Car Service
          </Link>
        </RoleGuard>
      </div>

      
      {/* <div className="grid gap-4 md:grid-cols-3 mb-8">
        <div className="p-4 bg-card rounded-lg border shadow-sm">
          <div className="flex items-center gap-2 text-muted-foreground mb-2">
            <Settings className="h-4 w-4" />
            <span className="text-sm font-medium">Total Services</span>
          </div>
          <p className="text-2xl font-bold">
            {isPending ? "Loading..." : carServices?.length}
          </p>
        </div>
        
      </div> */}

      
      <div className="">
        <CarServicesList />
      </div>
    </div>
  );
}

const CarServicesPage = withAuthorization(CarServices, [
  Role.CompanyAdmin,
  Role.SuperAdmin,
  Role.Employee,
]);

export default CarServicesPage;
